import { render } from "./GameOverviewView.vue?vue&type=template&id=f232adc0"
import script from "./GameOverviewView.vue?vue&type=script&lang=js"
export * from "./GameOverviewView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__